// extracted by mini-css-extract-plugin
export default {"changeBasemap":"Map_changeBasemap__vE8iv"};